import React, { useEffect } from "react";
import "./studentMetrics.scss";
import SelfOnboardedStudentsIcon from "../../../assets/icons/self-onboarded-students.svg";
import StudentsIcon from "../../../assets/icons/students.svg";
import InstituteStudentsIcon from "../../../assets/icons/institute-students.svg";
import StudentMetricCard from "../StudentMetrics/StudentMetricCard";
import { useStudentActivities } from "../../../hooks/Institute/useStudentActivities";
import { useAllStudentActivities } from "../../../hooks/All/useAllStudentActivities";

const StudentMetrics: React.FC = () => {
  const {
    metrics,
    isLoading,
    loginCount,
    notLoggedInCount,
    activeCount,
    getActiveCount,
    getLoginCount,
    getNotLoggedInCount,
  } = useStudentActivities();
  const {
    totalAllCount,
    loginCount: allLoginCount,
    notLoginCount: allNotLoggedInCount,
  } = useAllStudentActivities();

  useEffect(() => {
    getNotLoggedInCount({});
    getLoginCount({});
    getActiveCount({});
  }, []);

  return (
    <div className="student-metrics">
      <StudentMetricCard
        title="Total Students"
        icon={StudentsIcon}
        count={totalAllCount}
        login={allLoginCount}
        notLogin={allNotLoggedInCount}
        isLoading={isLoading}
        className="total-students"
      />
      <StudentMetricCard
        title="Self Onboarded Students"
        icon={SelfOnboardedStudentsIcon}
        count={metrics?.totalSelfOnboardStudents}
        login={metrics?.totalSelfOnboardActiveStudents}
        notLogin={metrics?.totalSelfOnboardInactiveStudents}
        isLoading={isLoading}
        className="self-onboarded"
      />
      <StudentMetricCard
        title="Institute Students"
        icon={InstituteStudentsIcon}
        count={activeCount}
        login={loginCount}
        notLogin={notLoggedInCount}
        isLoading={isLoading}
        className="institute"
      />
    </div>
  );
};

export default StudentMetrics;
